<template>
<div class="max-w-md">

  <div
    class="relative mt-6 mb-12 flex flex-col items-top bg-white sm:items-center"
  >

  
    <div class="w-full p-2">
      <ul class="w-full flex flex-col">
      
        <li class="mb-4 rounded-lg shadow-md">
          <inertia-link :href="route('curricula')" class="flex flex-row">
          <div class="w-4/12 bg-white rounded-l-lg">
            <img src="/img/howto/howto-1.svg" class="p-3">
          </div>
          <div class="w-8/12 px-2 py-3  bg-blue-50 relative">
            <h4 class="font-bold text-blue-900">Completa altri programmi di miglioramento</h4>
            <ul class="flex flex-row bg-white py-1 px-2 rounded-full absolute bottom-3 w-auto">
             <li><img src="/img/osm-coin.png" alt="gem" class="px-2 h-6"></li>
             <li><img src="/img/osm-coin.png" alt="gem" class="px-2 h-6"></li>
             <li><img src="/img/osm-coin.png" alt="gem" class="px-2 h-6"></li>
            </ul>
          </div>
          </inertia-link>
        </li>

        <li class="mb-4 rounded-lg shadow-md">
           <div class="flex flex-row">
          <div class="w-4/12 bg-white rounded-l-lg">
            <img src="/img/howto/howto-2.svg" class="p-3">
          </div>
          <div class="w-8/12 px-2 py-3  bg-blue-50 relative">
          <h4 class="font-bold text-blue-900">Scarica la App I-OSM</h4>
          <div class="flex justify-between absolute bottom-3 w-11/12">
          <a href="https://apps.apple.com/it/app/iosm/id1502970051" target="blank" class="rounded-full py-1 px-4 bg-blue-600 text-white font-bold text-sm w-auto inline-block">download</a>
          <div class="flex flex-row bg-white px-2 rounded-full">
             <img src="/img/osm-coin.png" alt="gem" class="pr-1 h-6">
             <span class="text-blue-600 font-semibold text-lg">3x</span>
            </div>
          </div>  
          </div> 
           </div>
        </li>


        <li class="mb-4 rounded-lg shadow-md">
           <div class="flex flex-row">
          <div class="w-4/12 bg-white rounded-l-lg">
            <img src="/img/howto/howto-3.svg" class="p-3">
          </div>
          <div class="w-8/12 px-2 py-3  bg-blue-50 relative">
          <h4 class="font-bold text-blue-900 text-sm">Richiedi un approfondimento del tuo profilo<span class="text-sm"> (a pagamento)</span></h4>
          <div class="flex justify-between absolute bottom-3 w-11/12 mt-4">
          <a href="https://engageeditore.com/products/virtual-coach" target="blank" class="rounded-full py-1 px-4 bg-green-500 text-white font-bold text-sm w-auto inline-block">acquista</a>
          <div class="flex flex-row bg-white px-2 rounded-full">
             <img src="/img/osm-coin.png" alt="gem" class="pr-1 h-6">
             <span class="text-blue-600 font-semibold text-lg">10x</span>
            </div>
          </div>  
          </div> 
           </div>
        </li>

        <li class="mb-4 rounded-lg shadow-md">
           <div class="flex flex-row">
          <div class="w-4/12  bg-white rounded-l-lg">
            <img src="/img/howto/howto-4.svg" class="p-3">
          </div>
          <div class="w-8/12 px-2 py-3  bg-blue-50 relative">
          <h4 class="font-bold text-blue-900">Acquista un libro o un video corso OSM</h4>
          <div class="flex justify-between absolute bottom-3 w-11/12">
          <a href="https://engageeditore.com" target="blank" class="rounded-full py-1 px-4 bg-blue-600 text-white font-bold text-sm w-auto inline-block">acquista</a>
          <div class="flex flex-row bg-white px-2 rounded-full">
             <img src="/img/osm-coin.png" alt="gem" class="pr-1 h-6">
             <span class="text-blue-600 font-semibold text-lg">5x</span>
            </div>
          </div>  
          </div> 
           </div>
        </li>

        <!-- <div></div> -->


        <li class="mb-4 rounded-lg shadow-md">
           <div class="flex flex-row  h-22">
          <div class="w-4/12 bg-white rounded-l-lg">
            <img src="/img/howto/howto-5.svg" class="p-3">
          </div>

          <form @submit.prevent="submitContact" class="w-8/12 px-2 py-3  bg-blue-50 relative">

          <div v-if="step === 0" class="w-full  bg-blue-50 relative">
          <h4 class="font-bold text-blue-900">Iscriviti a un evento gratuito OSM</h4>
          <div class="flex justify-between w-11/12">
          <div @click="step = 1" class="rounded-full py-1 px-4 bg-pink-500 text-white font-bold text-sm w-auto inline-block">contattaci</div>
          <div class="flex flex-row bg-white px-2 rounded-full">
             <img src="/img/osm-coin.png" alt="gem" class="pr-1 h-6">
             <span class="text-blue-600 font-semibold text-lg">5x</span>
            </div>
          </div>  
          </div>

          
          <div v-if="step === 1" class="w-full   bg-blue-50 relative">
          <h4 class="font-bold text-blue-900">In quale città vorresti l'evento?</h4>
          <input type="text" id="rounded-email" v-model="city" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="La tua città"/>
          <div class="flex justify-between  w-11/12">
          <div @click="step = 2" class="rounded-full py-1 px-4 bg-green-600 text-white font-bold text-sm w-auto inline-block">continua</div>
          <div class="flex flex-row bg-white px-2 rounded-full">
             <img src="/img/osm-coin.png" alt="gem" class="pr-1 h-6">
             <span class="text-blue-600 font-semibold text-lg">5x</span>
            </div>
          </div>
          </div>
          

          <div v-if="step === 2" class="w-full   bg-blue-50 relative">
            <h4 class="font-bold text-blue-900">Qual è il tuo numero di telefono?</h4>
            <input type="text" v-model="tel" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Telefono"/>
            <div class="flex justify-between  w-11/12">
              <div @click="step = 3" class="rounded-full py-1 px-4 bg-green-600 text-white font-bold text-sm w-auto inline-block">invia</div>
              <div class="flex flex-row bg-white px-2 rounded-full">
                <img src="/img/osm-coin.png" alt="gem" class="pr-1 h-6">
                <span class="text-blue-600 font-semibold text-lg">5x</span>
              </div>
            </div>
          </div>

          <div v-if="step === 3" class="w-full   bg-blue-50 relative">
          <h4 class="font-bold text-blue-900">Sei un imprenditore?</h4>
          <div class="flex justify-between  w-11/12">

          <button value="1" @click="step = 4, company = '1'" class="rounded-full py-1 px-4 bg-blue-600 text-white font-bold text-sm w-auto inline-block">sì</button>
          <button value="0" @click="step = 4, company = '0'" class="rounded-full py-1 px-4 bg-blue-600 text-white font-bold text-sm w-auto inline-block">no</button>
          
          <div class="flex flex-row bg-white px-2 rounded-full">
             <img src="/img/osm-coin.png" alt="gem" class="pr-1 h-6">
             <span class="text-blue-600 font-semibold text-lg">5x</span>
            </div>
          </div>
          </div>


          <div v-if="step === 4" class="w-full  bg-blue-50 relative">
          <h4 class="font-bold text-blue-900">Grazie! Verrai contattato a breve per l'evento più vicino</h4>
          <div class="flex justify-between  w-11/12">
          <button @click="step = 0" class="rounded-full py-1 px-4 bg-blue-600 text-white font-bold text-sm w-auto inline-block">ok</button>
          <div class="flex flex-row bg-white px-2 rounded-full">
             <img src="/img/osm-coin.png" alt="gem" class="pr-1 h-6">
             <span class="text-blue-600 font-semibold text-lg">5x</span>
            </div>
          </div>  
          </div> 

          </form> 

           </div>
        </li>


        <li class="mb-4 rounded-lg shadow-md">
           <div class="flex flex-row  h-22">
          <div class="w-4/12 bg-white rounded-l-lg">
            <img src="/img/howto/howto-6.svg" class="p-3">
          </div>
          
          <div class="w-8/12 px-2 py-3  bg-blue-50 relative">
          <form @submit.prevent="submitIosm">

         <div v-show="!askEmail && !okThanks" class="w-full  bg-blue-50 relative">
           <h4 class="font-bold text-blue-900">Completa un programma della APP iOsm</h4>
            <div class="flex justify-between  w-11/12">
            <div @click="askEmail = true" class="rounded-full py-1 px-4 bg-blue-600 text-white font-bold text-sm w-auto inline-block">richiedi</div>
            <div class="flex flex-row bg-white px-2 rounded-full">
             <img src="/img/osm-coin.png" alt="gem" class="pr-1 h-6">
             <span class="text-blue-600 font-semibold text-lg">1x</span>
            </div>
          </div>  
          </div>

          <div v-show="askEmail" class="w-full  bg-blue-50 relative">
            <h4 class="font-bold text-blue-900">Email con cui sei registrato sulla app iOsm</h4>
            <input type="email" id="rounded-email" v-model="email" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="La tua email in app iOsm"/>
            <div class="flex justify-between  w-11/12">
            <button type="submit" @click="askEmail = false, okThanks = true" class="rounded-full py-1 px-4 bg-green-600 text-white font-bold text-sm w-auto inline-block">invia</button>
            <div class="flex flex-row bg-white px-2 rounded-full">
             <img src="/img/osm-coin.png" alt="gem" class="pr-1 h-6">
             <span class="text-blue-600 font-semibold text-lg">1x</span>
            </div>
            </div>
          </div>
          </form>

          <div v-show="okThanks" class="w-full  bg-blue-50 relative">
          <h4 class="font-bold text-blue-900">Grazie! Verrai contattato a breve per l'assegnazione di OSM Coin</h4>
          <div class="flex justify-between  w-11/12">
          <button @click="okThanks = false" class="rounded-full py-1 px-4 bg-blue-600 text-white font-bold text-sm w-auto inline-block">ok</button>
          <div class="flex flex-row bg-white px-2 rounded-full">
             <img src="/img/osm-coin.png" alt="gem" class="pr-1 h-6">
             <span class="text-blue-600 font-semibold text-lg">1x</span>
            </div>
          </div>  
          </div>

          </div>

           </div>
           
        </li>


        <li class="mb-4 rounded-lg shadow-md">
           <div class="flex flex-row">
          <div class="w-4/12 bg-white rounded-l-lg">
            <img src="/img/howto/howto-7.svg" class="p-3">
          </div>
          <div class="w-8/12 px-2 py-3  bg-blue-50 relative">

          <div v-show="!okQuestion">
          <h4 class="font-bold text-blue-900">Richiedi altri OSM Coin</h4>
          <form @submit.prevent="submitQuestion">
            <select v-if="selected != 3" v-model="selected"  class="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2">
                <option value="1">completato mio programma app</option>
                <option value="2">completato tutta la app iOsm</option>
                <option value="3">partecipato ad evento / corso</option>
                <option value="4">altro...</option>
            </select>

            <div v-if="selected === '3'">

            <div v-show="eventstep == 1">
              <input type="text" maxlength="50" v-model="eventplace" class="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Dove?"/>
              <div @click="eventstep = 2" class="rounded-full py-1 px-4 bg-green-600 text-white font-bold text-sm w-auto inline-block">invia</div>
            </div>

              <div v-show="eventstep == 2">
                <input type="text" maxlength="50" v-model="eventdate" class="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Quando?"/>
                <div @click="eventstep = 3" class="rounded-full py-1 px-4 bg-green-600 text-white font-bold text-sm w-auto inline-block">invia</div>
              </div>

              <div v-show="eventstep == 3">
                <input type="text" maxlength="50" v-model="eventtitle" class="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Qual era il titolo?"/>
                <div @click="eventstep = 4" class="rounded-full py-1 px-4 bg-green-600 text-white font-bold text-sm w-auto inline-block">invia</div>
              </div>
           
           <div v-show="eventstep == 4">
              <input type="text" maxlength="50" v-model="eventspeaker" class="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Chi era il relatore?"/>
              <button type="submit" @click="okQuestion = true" class="rounded-full py-1 px-4 bg-green-600 text-white font-bold text-sm w-auto inline-block">invia</button>
           </div>
            
           
            
            </div>

           
          
 
          <div v-if="selected === '4'">
            <input type="text" maxlength="50" v-model="motive" class="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Motiva la richiesta"/>
            <button type="submit" @click="okQuestion = true" class="rounded-full py-1 px-4 bg-green-600 text-white font-bold text-sm w-auto inline-block">invia</button>
          </div>

          </form>

          </div>

          <div v-show="okQuestion" class="w-full  bg-blue-50 relative">
              <h4 class="font-bold text-blue-900">Grazie! Verrai contattato a breve per l'assegnazione di OSM Coin</h4>
            </div>

          </div> 
           </div>
        </li>


        <!--codici promo-->
        <li class="mb-4 rounded-lg shadow-md">
           <div class="flex flex-row">
          <div class="w-4/12 bg-white rounded-l-lg">
            <img src="/img/howto/howto-8.svg" class="p-3">
          </div>
          <div class="w-8/12 px-2 py-3  bg-blue-50 relative">

          <div v-show="!okPromo">
          <h4 class="font-bold text-blue-900">Inserisci qui il codice promozionale</h4>
          <form @submit.prevent="submitPromo">
            <input type="text" maxlength="10" v-model="promocode" class="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-1 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Il tuo codice promo"/>
            <button type="submit" @click="okPromo = true" class="rounded-full py-1 px-4 bg-green-600 text-white font-bold text-sm w-auto inline-block">invia</button>
          </form>
          </div>

          <div v-show="okPromo" class="w-full  bg-blue-50 relative">
              <h4 class="font-bold text-blue-900">Grazie! Verrai contattato a breve.</h4>
            </div>

          </div>


           </div>
        </li>


      </ul>
    </div>
      <BottomBar :diamonds="diamonds"/>
  </div>
  </div>
</template>

<script>
import BottomBar from "@/Layouts/BottomBar";

export default {
  props: ["diamonds"],
  components: {
    BottomBar
  },
  data() {
    return {
      city: this.city,
      tel: this.tel,
      company: 0,
      promocode: this.promocode,
      step: 0,
      askEmail: false,
      okThanks: false,
      okQuestion: false,
      eventstep: 1,
      okPromo: false,
      email: this.email,
      motive:this.motive,
      selected: this.selected,
      eventplace: this.eventplace,
      eventdate: this.eventdate,
      eventtitle: this.eventtitle,
      eventspeaker: this.eventspeaker
    };
  },
  methods: {
    submitContact() {
      const data = new FormData()
      data.append('city', this.city);
      data.append('tel', this.tel);
      data.append('company', this.company);
      this.$inertia.post(this.route('contact.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
    submitIosm() {
      const data = new FormData()
      data.append('email', this.email);

      this.$inertia.post(this.route('users.iosm'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
    submitPromo() {
      const data = new FormData()
      data.append('promocode', this.promocode);

      this.$inertia.post(this.route('users.promo'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
    submitQuestion() {
      const data = new FormData()
      data.append('motive', this.motive);
      data.append('selected', this.selected);

      data.append('eventplace', this.eventplace);
      data.append('eventdate', this.eventdate);
      data.append('eventtitle', this.eventtitle);
      data.append('eventspeaker', this.eventspeaker);

      this.$inertia.post(this.route('ask.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    }
  }
};
</script>

<style>

</style>